// import React, { useEffect, useState } from 'react';
// import { Card, CardContent, Grid, Stack } from '@mui/material';
// import { useDispatch } from 'react-redux';
// import { useSelector } from 'react-redux';

// const NotificationCardHyperdrive = () => {
//   const dispatch = useDispatch();
//   const { addHyperdriveNotifications = [] } = useSelector(state => state.notifications);


//   return (
//     <Grid container justifyContent="flex-end" spacing={2} style={{
//       position: 'fixed', top: 88, zIndex: 999,
//       display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', gap: 16,
//     }} >
//       {addHyperdriveNotifications?.map((notification) => (
//         <>
//           <Card className="align-items-start flex-column notification-contents notification-pop" key={notification.type} style={{}}>
//             <CardContent >
//               <h4>{notification?.notificationData?.title}</h4>
//               <p><strong>Product Name:</strong> {notification.title}</p>
//               <p><strong>Store Name:</strong> {notification.fleetName}</p>        
//             </CardContent>
//           </Card>
//         </>

//       ))}
//     </Grid>
//   );
// };

// export default NotificationCardHyperdrive;
//===========================================================
// import React, { useEffect } from 'react';
// import { Card, CardContent, Grid, IconButton, Stack } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import { useDispatch, useSelector } from 'react-redux';
// import { RemoveHyperdriveNotification } from '../../redux/slices/notifications';

// const NotificationCardHyperdrive = () => {
//   const dispatch = useDispatch();
//   const { addHyperdriveNotifications = [] } = useSelector(
//     (state) => state.notifications
//   );

//   // Auto-remove after 5 sec
//   useEffect(() => {
//     addHyperdriveNotifications.forEach((_, index) => {
//       const timer = setTimeout(() => {
//         dispatch(RemoveHyperdriveNotification(index));
//       }, 500000); // 5000
//       return () => clearTimeout(timer);
//     });
//   }, [addHyperdriveNotifications, dispatch]);

//   return (
//       <Grid container justifyContent="flex-end" spacing={2} style={{
//       position: 'fixed', top: 88, zIndex: 999,
//       display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', gap: 16,
//     }} >
//       {addHyperdriveNotifications?.map((notification, index) => (
//         <Card
//           key={index}
//           className="notification-pop"
//         >

//           <IconButton
//             size="small"
//             onClick={() => dispatch(RemoveHyperdriveNotification(index))}
//             // style={{ position: 'absolute', top: 4, right: 4 }}
//           >
//             <CloseIcon fontSize="small" />
//           </IconButton>
//           <CardContent>
//             <h4>{notification?.notificationData?.title}</h4>
//             <p>
//               <strong>Product Name:</strong> {notification.title}
//             </p>
//             <p>
//               <strong>Store Name:</strong> {notification.fleetName}
//             </p>
//           </CardContent>
//         </Card>
//       ))}
//     </Grid>
//   );
// };

// export default NotificationCardHyperdrive;


import React, { useEffect, useState } from 'react';
import { Card, CardContent, Grid, IconButton, Stack, LinearProgress, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { RemoveHyperdriveNotification } from '../../redux/slices/notifications';

const NotificationCardHyperdrive = () => {
  const dispatch = useDispatch();
  const { addHyperdriveNotifications = [] } = useSelector(
    (state) => state.notifications
  );
  
  // State to track timers for each notification
  const [timers, setTimers] = useState({});

  // Auto-remove after 5 sec with countdown
  useEffect(() => {
    addHyperdriveNotifications.forEach((notification, index) => {
      // Skip if timer already exists for this notification
      if (timers[index]) return;

      // Initialize countdown for this notification
      // setTimers(prev => ({ ...prev, [index]: 10 }));

      // Create countdown interval
      const countdownInterval = setInterval(() => {
        setTimers(prev => {
          const currentTime = prev[index];
          if (currentTime <= 1) {
            // Time's up, remove notification
            dispatch(RemoveHyperdriveNotification(index));
            clearInterval(countdownInterval);
            const newTimers = { ...prev };
            delete newTimers[index];
            return newTimers;
          }
          return { ...prev, [index]: currentTime - 1 };
        });
      }, 1000);

      // Cleanup function
      return () => {
        clearInterval(countdownInterval);
        setTimers(prev => {
          const newTimers = { ...prev };
          delete newTimers[index];
          return newTimers;
        });
      };
    });
  }, [addHyperdriveNotifications, dispatch, timers]);

  // Manual remove handler
  const handleRemoveNotification = (index) => {
    dispatch(RemoveHyperdriveNotification(index));
    setTimers(prev => {
      const newTimers = { ...prev };
      delete newTimers[index];
      return newTimers;
    });
  };

  return (
    <Grid 
      container 
      justifyContent="flex-end" 
      spacing={2} 
      style={{
        position: 'fixed', 
        top: 88, 
        right: 16,
        zIndex: 999,
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'flex-end', 
        alignItems: 'flex-end', 
        gap: 12,
        maxWidth: 300,
      }} 
      className='notification-alert'
    >
      {addHyperdriveNotifications?.map((notification, index) => (
        <Card key={index} className="notification-pop">
          {/* Close Button */}
          <IconButton
            size="small"
            onClick={() => handleRemoveNotification(index)}
            // style={{ 
            //   position: 'absolute', 
            //   top: 8, 
            //   right: 8,
            //   zIndex: 1,
            // }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <CardContent>
            <Typography variant="h6" component="h4" gutterBottom>
              {notification?.notificationData?.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              <strong>Title: </strong> {notification.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              <strong>Driver Name:</strong> {notification.fleetName}
            </Typography>
            
            {/* Timer Section */}
            {/* <div style={{ marginTop: 16 }}>
              <Stack direction="row" alignItems="center" spacing={1} style={{ marginBottom: 8 }}>
                <Typography variant="caption" color="text.secondary">
                  Auto-close in: 
                </Typography>
                <Typography 
                  variant="caption" 
                  color="primary" 
                  style={{ 
                    fontWeight: 'bold',
                    minWidth: 20,
                  }}
                >
                  {timers[index] || 0}s
                </Typography>
              </Stack>
              
              <LinearProgress 
                variant="determinate" 
                value={((timers[index] || 0) / 5) * 100} 
                style={{
                  height: 4,
                  borderRadius: 2,
                }}
                color="primary"
              />
            </div> */}
          </CardContent>
        </Card>
      ))}
    </Grid>
  );
};

export default NotificationCardHyperdrive;